import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-05/lesson-14/task-01";

const task: Slide = {
  title: "Listen to the audio file and try to find the corresponding configuration of the room.",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [0.5, 4],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "Play audio",
                  theme: "secondary",
                  shape: "round",
                  icon: "cis-volume-high",
                  url: `${config.ASSETS_URL}/05/14/task/task-1-audio.wav`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
